import { withI18n } from 'react-i18next';
import EmptyStatement from './EmptyStatement';

export const pureComponent = EmptyStatement;
export default withI18n()(EmptyStatement);
